import { PathOptions } from "leaflet";

export const rios = (feature: any): PathOptions => {
  return {
    color: "#009eeb",
    weight: 1,
    opacity: 1,
  };
};
